import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore, AUTH_ERROR_CODES } from "../stores/authStore";
import { handlePortaleHandshake } from "../lib/auth";

export function useAuth() {
  const {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    errorCode,
    logout,
    setError,
    initFromStorage,
  } = useAuthStore();

  // Initialize auth state from storage on mount
  useEffect(() => {
    initFromStorage();
  }, [initFromStorage]);

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    errorCode,
    logout,
    setError,
    // Export error codes for consumers
    AUTH_ERROR_CODES,
  };
}

export function useRequireAuth() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  return { isAuthenticated, isLoading };
}

export function useHandshake() {
  const { setUser, setLoading, setError } = useAuthStore();
  const navigate = useNavigate();

  const processHandshake = async (jwt: string) => {
    setLoading(true);
    
    try {
      const result = await handlePortaleHandshake(jwt);
      
      if (result.success && result.user) {
        setUser(result.user, jwt);
        navigate("/dashboard", { replace: true });
      } else {
        setError(result.error || "Autenticazione fallita");
        navigate("/login", { replace: true });
      }
    } catch (error) {
      console.error("Handshake error:", error);
      setError("Errore durante l'autenticazione");
      navigate("/login", { replace: true });
    }
  };

  return { processHandshake };
}

